export const ROLES = {
  ADMIN: 'Admin',
  STAFF: 'Staff',
  USER: 'User'
}
